import Dinero from "dinero.js";
import smoothscroll from "smoothscroll-polyfill";
import fecha from "fecha";
// import "../JS/hotel-datepicker.min.js";

// function isLocalStorage(){
//   var test = 'test';
//   try {
//       localStorage.setItem(test, test);
//       localStorage.removeItem(test);
//       console.log("localstorage yes");
//       return true;
//   } catch(e) {
//     console.log("localstorage no");
//       return false;
//   }
// };

export const dateWithoutTime = function (date) {
  return date;
};

export const isBetweenStornoDate = function(startdate) {

  const priceChangeDay = new Date('2022-11-30');
  var bookingDay = new Date(startdate);
  var today = new Date();
  

  if (bookingDay > priceChangeDay) {
    var threeMonthBeforeBookingDay = new Date(bookingDay.getTime() - 90 * 24 * 60 * 60 * 1000);
    if (today.getTime() <= bookingDay.getTime()  && today.getTime() <= threeMonthBeforeBookingDay.getTime()) {
      return fecha.format(threeMonthBeforeBookingDay, 'DD.MM.YYYY');
     } else {
       return null;
     } 
    } else {
      var weekBeforeBookingDay = new Date(bookingDay.getTime() - 7 * 24 * 60 * 60 * 1000);
      if (today.getTime() <= bookingDay.getTime()  && today.getTime() <= weekBeforeBookingDay.getTime()) {
       return fecha.format(weekBeforeBookingDay, 'DD.MM.YYYY');
      } else {
        return null;
      }
     }
};


export const niceDate = function(d) {
  var date = new Date(d);
  return fecha.format(date, 'DD.MM.YYYY');

};

export const storeLocal = function(val) {
  // console.log("xx");
 localStorage.setItem('reservation',JSON.stringify(val))
  // if (this.isLocalStorage() ) { /* is localstorage  supported*/
  //   localStorage.setItem('reservation',JSON.stringify(val))
  // }
};

export const scrollToElement = function (el,timeout) {
  smoothscroll.polyfill();
  window.__forceSmoothScrollPolyfill__ = true;
  var element = "#" + el;
  element = document.querySelector(element);
  var offsetPosition = element.offsetTop;
  
  if(!timeout) timeout = 500;
  setTimeout(()=>{
    offsetPosition = element.offsetTop;
    window.scrollTo({
      top: offsetPosition - 80,
      left: 0,
      behavior: "smooth",
    });
  },timeout)
  return true;
};

export const scrollIntoViewToElement = function (el) {
  document
    .getElementById(el)
    .scrollIntoView({ left: 0, block: "start", behavior: "smooth" });

  console.log(el);

  return true;
};

export const trackEvent = function(category, action, name) {
  var host = window.location.hostname;
  if (host=="192.168.0.66") {
    console.log(name);
} else {
  // eslint-disable-next-line no-undef
  // no tracking on dev
  // _paq.push(['trackEvent', category, action, name]);
}
};

export const toPrice = function (amount, factor = Math.pow(10, 2)) {
  var retval = Dinero({
    amount: Math.round(amount * factor),
    //amount: amount * factor,
    currency: "EUR",
  })
  .setLocale('de')
 // .setLocale(this.$i18n.locale)
    .toFormat("$0,0");
  //console.log(retval);
  return retval;
};

// window.addEventListener('scroll', function() {
//   if(window.scrollY > document.querySelector('.vue-wrap').offsetTop) {
//     document.querySelector('body').classList.add('vue-nav-fixed');
//   } else {
//     document.querySelector('body').classList.remove('vue-nav-fixed');
//   }
// })